import axios from '@/plugins/axios'

export function getRechargeConfiguration(params = {}) {
  return axios.get('recharge_configuration', { params })
}

export function storeRechargeConfiguration(data) {
    return axios.post('recharge_configuration', data)
}

export function destroyRechargeConfiguration(id) {
    return axios.delete(`recharge_configuration/${id}`)
}

export function updateRechargeConfiguration(id, data) {
    return axios.put(`recharge_configuration/${id}`, data)
}

export function editRechargeConfiguration(id) {
    return axios.get(`recharge_configuration/${id}/edit`)
}
